import { OfficeMirror } from "@/system/OfficeMirror";

export function HomePage() {
  return <OfficeMirror />;
}
